// @flow
import gql from 'graphql-tag'
import type { ProfileEnrollment } from 'types/profile'
import { type ProfileMedia, PROFILE_MEDIA_FRAGMENT } from './profile_media'

export type Profile = {
  id: number,
  ageMonthsMax: number | null,
  ageMonthsMin: number | null,
  philosophy: string | null,
  language: string | null,
  languageOther: string | null,
  pottyTrainingRequired: boolean | null,
  providerChildRatioConsequent: number | null,
  snacksProvidedCount: number | null,
  mealsBreakfastProvided: boolean | null,
  mealsLunchProvided: boolean | null,
  mealsDinnerProvided: boolean | null,
  daysOfWeek: boolean[],
  hourlyRate: number,
  hoursStart: string | null,
  hoursEnd: string | null,
  profileMedia: ProfileMedia[],
  content: string,
  enrollment: ProfileEnrollment | null,
}

export const PROFILE_FRAGMENT = gql`
  fragment profile on Profile {
    id
    ageMonthsMax
    ageMonthsMin
    philosophy
    language
    languageOther
    pottyTrainingRequired
    providerChildRatioConsequent
    snacksProvidedCount
    mealsBreakfastProvided
    mealsLunchProvided
    mealsDinnerProvided
    daysOfWeek
    hourlyRate
    hoursStart
    hoursEnd
    content
    enrollment
    profileMedia {
      ...profileMedia
    }
  }

  ${PROFILE_MEDIA_FRAGMENT}
`
